import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTPListener, HTTPStatus } from './interceptor/HTTPListener';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { RouteReuseService } from './route-reuse/route-reuse-service';
import { MainComponent } from './layout/main/main.component';
import { SharedModule } from './component/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { UnderMainatanceComponent } from './pages/under-mainatance/under-mainatance.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPassPageComponent } from './pages/reset-pass/reset-pass-page.component';
import { DeleteConfirmationDialogComponent } from './component/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { ActiveInactiveDialogComponent } from './component/active-inactive-dialog/active-inactive-dialog.component';
import { ConfirmationDialogComponent } from './component/confirmation-dialog/confirmation-dialog.component';
import { ImageUploadConfirmationDialogComponent } from './component/image-upload-confirmation-dialog/image-upload-confirmation-dialog.component';
import { SafeUrlPipe } from './services/common/safeUrl.pipe';
import { CalendarActionDialogComponent } from './component/calendar-action-dialog/calendar-action-dialog.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ChatGptComponent } from './component/chat-gpt/chat-gpt.component';
import {
  NgbAccordionModule,
  NgbActiveModal,
  NgbCollapseModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  MatExpansionModule,
  MatAccordion,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { NoAccessPageComponent } from './pages/no-access-page/no-access-page.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ClaimByProjectModule } from './pages/claim-workflow/claim-by-project/claim-by-project.module';
import { VerificationCodeComponent } from './pages/verification-code/verification-code.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { LoginDevicesListComponent } from './pages/login-devices-list/login-devices-list.component';
import { PrivacyLegalDialogComponent } from './pages/privacy-legal-dialog/privacy-legal-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { RequiredFormConfirmationModelComponent } from './component/required-form-confirmation-model/required-form-confirmation-model/required-form-confirmation-model.component';
import { AiConfirmationDialogComponent } from './component/ai-confirmation-dialog/ai-confirmation-dialog.component';
import { CommonCkEditorComponent } from './component/common-ck-editor/common-ck-editor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { routes } from './app.routes';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DraggableDirective } from './core/directive/directive/draggable.directive';
import { AiChatDialogComponent } from './component/ai-chat-dialog/ai-chat-dialog.component';
import { environment } from '../environments/environment';
const RxJS_Services = [HTTPListener, HTTPStatus];

@NgModule({
  declarations: [
    DraggableDirective,
    AppComponent,
    MainComponent,
    UnderMainatanceComponent,
    LoginComponent,
    VerificationCodeComponent,
    ForgotPasswordComponent,
    ResetPassPageComponent,
    DeleteConfirmationDialogComponent,
    ActiveInactiveDialogComponent,
    ConfirmationDialogComponent,
    ImageUploadConfirmationDialogComponent,
    CalendarActionDialogComponent,
    ChatGptComponent,
    NoAccessPageComponent,
    ChangePasswordComponent,
    PrivacyLegalDialogComponent,
    RequiredFormConfirmationModelComponent,
    LoginDevicesListComponent,
    AiConfirmationDialogComponent,
    AiChatDialogComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({ closeButton: true }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatDialogModule,
    MatSelectModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatPaginatorModule,
    MatTooltipModule,
    RouterModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatSlideToggleModule,
    BrowserModule,
    MatMenuModule,
    MatButtonModule,
    NgbModule,
    MatExpansionModule,
    MatAccordion,
    MatExpansionPanel,
    NgbAccordionModule,
    ClaimByProjectModule,
    NgbCollapseModule,
    NgOtpInputModule,
    CKEditorModule,
    //DragDropModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReuseService,
    },
    RxJS_Services,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HTTPListener,
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.siteKey,
      } as RecaptchaSettings,
    },
    SafeUrlPipe,
    NgbActiveModal,
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
